export class RegraSelecaoModel {
    id: string;

    nome: string;
}
